import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import classNames from "classnames";

import { validate } from "./validation";

class FormBuilder extends Component {
  renderField = props => {
    const {
      input,
      id,
      label,
      type,
      disabled,
      groupName,
      labelPositionBottom,
      meta: { touched, error }
    } = props;
    let inputClass = classNames("usa-input", {
      "usa-checkbox__input": type === "checkbox",
      "usa-radio__input": type === "radio",
      "usa-input-error": touched && error
    });
    let labelClass = classNames({
      "usa-checkbox__label": type === "checkbox",
      "usa-radio__label": type === "radio"
    });

    return (
      <div className={`usa-${type}`}>
        {!labelPositionBottom && (
          <label className={labelClass} htmlFor={id}>
            {label}
          </label>
        )}
        <input
          {...input}
          type={type}
          className={inputClass}
          id={type === "text" ? "input-type-text" : id}
          disabled={disabled}
          name={groupName || id}
        />
        {labelPositionBottom && (
          <label className={labelClass} htmlFor={id}>
            {label}
          </label>
        )}
        {touched &&
          (error && (
            <span
              className="usa-error-message"
              id="input-error-message"
              role="alert"
            >
              {error}
            </span>
          ))}
      </div>
    );
  };

  buildForm() {
    const { model } = this.props;
    return model.map((m, i) => {
      let gridSize = m.size || 12;
      let title = m.title ? m.title : false;
      return (
        <li key={i} className={`grid-col-${gridSize}`}>
          {title && <h4>{title}</h4>}
          <Field
            name={m.name || m.key}
            id={m.key}
            groupName={m.name}
            value={m.key}
            type={m.type}
            disabled={m.disabled}
            labelPositionBottom={m.labelPositionBottom || false}
            component={m.component || this.renderField}
            label={m.label}
          />
        </li>
      );
    });
  }

  render() {
    const { model } = this.props;
    if (model) {
      return (
        <form className="usa-form">
          <fieldset className="usa-fieldset">
            <ul className="grid-row-full">{this.buildForm()}</ul>
          </fieldset>
        </form>
      );
    } else {
      return null;
    }
  }
}
export default reduxForm({
  form: "WelcomeModal",
  validate
})(FormBuilder);
